import { i18next } from '@/i18n'
import store from '../store'

export default {
  path: 'posts/',
  meta: {
    auth: 'ROLE_USER',
    title: i18next.t('routes.adsTitle')
  },
  component: () =>
    import(/* webpackChunkName: "posts" */ '../pages/posts/Posts.vue'),
  children: [
    {
      path: '',
      name: 'posts',
      meta: {
        title: i18next.t('routes.adsListTitle')
      },
      props: { resetParent: false },
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/List/PostsList.vue')
    },
    {
      path: 'lots/:programId',
      name: 'posts-lots',
      meta: {
        title: i18next.t('posts.list.pageTitleLots')
      },
      props: true,
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/List/PostsList.vue')
    },
    {
      path: 'content-library',
      name: 'content-library',
      meta: {
        title: i18next.t('routes.contentLibrary')
      },
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/List/PostsList.vue')
    },
    {
      path: 'manage-posts/:id',
      name: 'manage-posts',
      props: true,
      meta: {
        title: i18next.t('routes.managePosts')
      },
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/SocialMedia/PostManager.vue')
    },
    {
      path: 'bien-vendu/new',
      name: 'new-bien-vendu',
      meta: {
        title: i18next.t('routes.newBienVendu')
      },
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/BienVendu/BienVendu.vue')
    },
    {
      path: 'bien-vendu/:id/edit',
      name: 'edit-bien-vendu',
      meta: {
        title: i18next.t('routes.editBienVendu')
      },
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/BienVendu/BienVendu.vue')
    },

    {
      path: 'new',
      name: 'post-new',
      meta: {
        title: i18next.t('routes.createAdTitle')
      },
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/Manage/PostEdit.vue')
    },
    {
      path: 'newmodel/:type',
      name: 'post-new-model',
      meta: {
        title: i18next.t('routes.createAdModelTitle')
      },
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/Manage/PostEdit.vue')
    },
    {
      path: ':post/view',
      name: 'post-view',
      meta: {
        title: i18next.t('routes.adDetailsTitle')
      },
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/View/PostView.vue')
    },
    {
      path: ':post/view-selection-vo',
      name: 'post-view-selection-vo',
      meta: {
        title: i18next.t('routes.adDetailsTitle')
      },
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/View/PostViewSelectionVo.vue')
    },
    {
      path: ':id/edit',
      name: 'post-edit',
      meta: {
        title: i18next.t('routes.editAdTitle')
      },
      props: (route) => ({ query: route.query.saisie }),
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/Manage/PostEdit.vue')
    },
    {
      path: ':id/editmodel',
      name: 'model-edit',
      meta: {
        title: i18next.t('posts.edit.pageTitleModele')
      },
      props: (route) => ({ query: route.query.saisie }),
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/Manage/PostEdit.vue')
    },
    {
      path: ':id/private-note',
      name: 'private-note',
      meta: {
        title: i18next.t('routes.PrivateNote')
      },
      props: (route) => ({ query: route.query.saisie }),
      component: () =>
        import(/* webpackChunkName: "posts" */ '../pages/posts/PrivateNote.vue')
    },
    {
      path: 'attendance/:post',
      name: 'attendance-report-post',
      meta: {
        title: i18next.t('routes.presenceReportTitle')
      },
      beforeEnter: (to, from, next) => {
        if (!store.getters.getSitimmoUser.garantiePublication) {
          return next({ name: '403', params: { redirect: to.fullPath } })
        }
        return next()
      },
      component: () =>
        import(
          /* webpackChunkName: "portals" */ '../pages/report/AttendanceReports.vue'
        )
    }
  ]
}
